import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import {
  getEngineTypes,
  getEngineType,
  createEngineType,
  editEngineType,
  deleteEngineType,
} from "api/engineTypeApi"

export const ENGINE_TYPE_QUERY_KEY = "engineTypes"

export const useEngineTypes = (params = {}, enabled = true) =>
  useQuery({
    queryKey: [ENGINE_TYPE_QUERY_KEY, params],
    queryFn: () => getEngineTypes(params),
    keepPreviousData: true,
    enabled
  })

export const useEngineType = (id) =>
  useQuery({
    queryKey: [ENGINE_TYPE_QUERY_KEY, id],
    queryFn: () => getEngineType(id),
    enabled: !!id,
  })

export const useCreateEngineType = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createEngineType,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([ENGINE_TYPE_QUERY_KEY])
    },
  })
}

export const useEditEngineType = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: editEngineType,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([ENGINE_TYPE_QUERY_KEY])
    },
  })
}

export const useDeleteEngineType = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteEngineType,
    onSuccess: (data) => {
      if (data?.success) queryClient.invalidateQueries([ENGINE_TYPE_QUERY_KEY])
    },
  })
}
